import { OrdersHistoryTableColumns } from 'src/mobx/ordersHistoryStore/types';

export const columnsWidth = {
  [OrdersHistoryTableColumns.OrderID]: 13,
  [OrdersHistoryTableColumns.BranchName]: 19, // 32
  [OrdersHistoryTableColumns.CustomerPhone]: 14, // 46
  [OrdersHistoryTableColumns.Status]: 15, // 61
  [OrdersHistoryTableColumns.CreatedAt]: 17, // 78
  [OrdersHistoryTableColumns.Details]: 15, // 93
  [OrdersHistoryTableColumns.TotalPrice]: 7,
};
